module.exports = __webpack_public_path__ + "img/check-mark-svgrepo-com.ee0ea434.svg";